"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Obsolete
var EnhancedHeadingCell = function EnhancedHeadingCell(OriginalComponent) {
  return OriginalComponent;
};

exports.default = EnhancedHeadingCell;


//////////////////
// WEBPACK FOOTER
// ./~/griddle-react/dist/module/components/TableHeadingCellEnhancer.js
// module id = 1290
// module chunks = 1